import { LeftIcon } from "@/components/Icons";
import { CSSProperties } from "react";
import classes from "./ArrowBoxButton.module.css";

interface Props {
	type: "left" | "right";
	onClick?: () => void;

	className?: string;
	id?: string;
	style?: CSSProperties;
}

const ArrowBoxButton = ({ type, onClick, className, id, style }: Props) => {
	const classNames = [
		classes.ArrowBoxButton,
		className,
		classes["icon" + type],
	];

	return (
		<button
			key={`${id ?? ''}-arrow-box-button`}
			id={id}
			className={classNames.join(" ")}
			onClick={onClick}
			style={style}>
			<LeftIcon className={classes.icon} />
		</button>
	);
};

export default ArrowBoxButton;
